(ns ncr.fragment.attachment-markup
  (:require ["bignumber.js" :as big]
            ["copy-to-clipboard" :as copy-to-clipboard]
            [cljs.reader :refer [read-string]]
            [clojure.core.async :as a :refer [go <!]]
            [clojure.string :as str]
            [cljs-http.client :as http]
            [ncr.backend :as b]
            [tick.core :as t]
            [uix.core.alpha :as uix]
            [ncr.etc.pf :as pf]
            [ncr.etc.util :as u]
            [ncr.etc.xform :as xf]
            [ncr.etc.zustand :as z]
            [ncr.widgets.pf :as wpf]
            [ncr.widgets.core :as w]
            [ncr.worker.util :as worker]))

(defn- has-markup? [attachment]
  (-> attachment :metadata :textract :status (= :ok)))

(defn write! [storage-key state]
  (.setItem js/localStorage storage-key (pr-str state)) state)

(defn read! [storage-key]
  (read-string (.getItem js/localStorage storage-key)))

(defn clear! [storage-key]
  (.removeItem js/localStorage storage-key))

(def write-show-markup! (partial write! ::show-markup?))
(def read-show-markup! #(or (read! ::show-markup?) false))

(defn- toggle-v [v block]
  (let [removed (remove #(= (:Id %) (:Id block)) v)]
    (if (= (count removed) (count v))
      (conj v block) (vec removed))))

(defn- get-suggestions [properties src]
  (reduce
    (fn [acc {:keys [type get-suggestions to-string]}]
      (if (and (nil? (get acc type)) type get-suggestions to-string)
        (assoc acc type (map to-string (get-suggestions src)))
        acc))
    {} properties))

(defn- apply-suggestion [event suggestions properties]
  (let [available-suggestions (remove (fn [[_ suggestions]] (empty? suggestions)) suggestions)]
    (when (= 1 (count available-suggestions))
      (let [[type suggestions] (first available-suggestions)
            affected (filter #(= type (:type %)) properties)]
        (when (= 1 (count affected))
          (let [{:keys [update!]} (first affected)]
            (update! (first suggestions) event)))))))

(defn update-suggestions [properties src]
  (hash-map :suggestions-src src :suggestions (get-suggestions (vals properties) src)))

(def ^z/Store useStore
  (z/create
    (fn [{:keys [fk f]}]
      (let [defaults {:active-blocks []
                      :suggestions-src ""
                      :suggestions {}}]
        (merge defaults
          {:toggle-markup #(fk :show-markup? (comp write-show-markup! not))
           :properties {}
           :update-blocks (fn [block event]
                            (f (fn [{:keys [active-blocks properties]}]
                                 (let [blocks (u/on-click-modifiers event
                                                {:on-ctrl-click (fn [_] (toggle-v active-blocks block))
                                                 :on-click (fn [_] (vector block))})
                                       {:keys [suggestions-src suggestions]}
                                       (update-suggestions properties (apply str (interpose " " (map :Text blocks))))]
                                   (when (= 2 (.-detail event)) ; double click
                                     (apply-suggestion event suggestions (vals properties)))
                                   {:active-blocks blocks
                                    :suggestions-src suggestions-src
                                    :suggestions suggestions}))))
           :set-suggestions-src (fn [src] (f #(update-suggestions (:properties %) src)))
           :clear! (fn [] (f (constantly defaults)))
           :set-attachment (fn [atm]
                             (f #(hash-map :attachment atm :show-markup? (when (has-markup? atm) (read-show-markup!))))
                             #(f (constantly defaults)))})))))

(defn register-property [id props]
  (.setState useStore
    (fn [state]
      (update state :properties assoc id
        (assoc (select-keys props [:update! :validate :type :to-string :get-suggestions]) :id id))))
  (fn [] (.setState useStore #(update % :properties dissoc id))))

(defmulti pre-process-type
  (fn [type _] type))

(def on-block-click (:update-blocks (.getState useStore))) ; TODO(df): remove from img_viewer after NCR-391 is done

(defn get-property-props [id {:keys [show-markup? properties suggestions-src suggestions]}]
  (let [{:keys [update! type]} (get properties id)
        suggestions (get suggestions type)]
    {:class (when show-markup?
              [:markup-registered
               (when (seq suggestions-src)
                 (if (seq suggestions) :markup-ready :markup-invalid))])
     :suggestions suggestions
     :c-suggestions (fn []
                      (when show-markup?
                        [pf/c-chip-group
                         (when (seq suggestions)
                           (for [value suggestions]
                             ^{:key value}
                             [wpf/c-chip value #(update! value)]))]))}))

(defn properties-view []
  (let [[show-markup? suggestions-src set-suggestions-src clear!]
        (.get useStore [:show-markup? :suggestions-src :set-suggestions-src :clear!])]

    (uix/effect! #(clear!) [])

    (when show-markup?
      [pf/c-card {:is-compact true}
       [pf/c-card-header "Toolbox"
        (when (seq suggestions-src)
          [pf/c-card-actions
           [pf/c-clipboard-copy-button
            {:variant :plain
             :on-click #(copy-to-clipboard suggestions-src)}
            "Copy to clipboard"]
           [pf/c-button {:variant :plain :class :pf-u-pr-0}
            [w/c-mdi-icon {:icon :close :on-click clear!}
             "Clear"]]])]
       [pf/c-card-body
        [pf/c-text-area
         {:style {:resize :vertical}
          :value suggestions-src
          :on-change (partial set-suggestions-src)}]]
       #_[pf/c-card-header "Registered properties"]
       #_(for [[id prop] properties]
           ^{:key id} [:div (pr-str prop)])])))

(defn- c-block [{:keys [active? block to-w to-h on-click money? date?]}]
  (let [{:keys [BlockType]} block
        {:keys [Width Height Left Top]} (-> block :Geometry :BoundingBox)
        [pw ph] (if (or money? date?) [4 4] [2 2])]

    [:div (merge
            {:class [:ncr-c-ocr-block
                     (when money? :ncr-c-ocr-block__money)
                     (when date? :ncr-c-ocr-block__date)
                     (when on-click :ncr-m-cursor-pointer)
                     (keyword (str "ncr-c-ocr-block__" (str/lower-case BlockType)))
                     (when active? :ncr-c-ocr-block__active)]
             :style {:position "absolute" :top (- (to-h Top) ph) :left (- (to-w Left) pw)
                     :height (+ (to-h Height) ph ph)
                     :width (+ (to-w Width) pw pw)}}
            (when on-click {:on-click on-click}))
     ; Text
     ]))

(defn toolbar-icon []
  (let [[show-markup? toggle-markup] (.get useStore [:show-markup? :toggle-markup])]
    (when-not (nil? show-markup?)
      [pf/c-toggle-group
       [pf/c-tooltip
        {:content [:span "Show OCR Markup"]}
        [pf/c-toggle-group-item
         {:icon [pf/c-ocr-file]
          :is-selected show-markup?
          :on-click toggle-markup
          :aria-label "show ocr markup"}]]])))

(defn ocr-markup-query [{:keys [id metadata reference-id]}]
  (when (-> metadata :textract :status (= :ok))
    [:attachment_load_metadata
     {:reference reference-id
      :attachment id
      :items nil} []]))

(defn- update-dates-and-moneys-page [{:keys [suggested-dates suggested-moneys] :as page}]
  (u/assoc-when page
    :suggested-dates (seq (map #(apply t/new-date %) suggested-dates))
    :suggested-moneys (seq (map #(big/BigNumber. %) suggested-moneys))))

(defn- update-dates-and-moneys [pages]
  (into {} (map (fn [[idx page]] [(js/parseInt (name idx)) (map update-dates-and-moneys-page page)]) pages)))

(def ^:private *in (volatile! nil))

(defn- start-worker [data]
  (let [[in out]
        (or @*in
          (let [out (a/chan (a/sliding-buffer 1)
                      (xf/create-simple-xform
                        (fn [v] (if (= "progress" (first v)) v (update-dates-and-moneys v)))))
                close-ch (a/chan)]
            (vreset! *in
              [(worker/worker-ch (js/Worker. "/js/worker.js")
                 (fn [from] (a/pipe from out) close-ch))
               out])))]
    (a/put! in data)
    out))

(defn fetch-ocr-markup [query]
  (go
    (when-let [{:keys [success body]}
               (some-> {:q query} b/!multi-query <! :q u/transit-read :textract :s3url
                 (http/get {:with-credentials? false}) <!)]
      (when success
        (let [out (start-worker body)]
          (loop []
            (if-let [blocks (<! out)]
              (if (= "progress" (first blocks))
                (recur)
                (do
                  (js/console.log "#markup loaded pages:" (count (keys blocks)))
                  (doseq [[k v] blocks]
                    (js/console.log "#markup page" k "blocks" (count v)))
                  blocks))
              (js/console.error "Worker channel closed"))))))))

(defn markup-viewer [{:keys [pages attachments]}]
  (let [[show-markup? attachment active-blocks update-blocks]
        (.get useStore [:show-markup? :attachment :active-blocks :update-blocks])
        query (uix/memo
                (fn []
                  (when (and (seq pages) attachment)
                    (ocr-markup-query attachment)))
                [pages attachment attachments])
        active-blocks-ids (set (map :Id active-blocks))
        page-blocks (uix/state nil)
        attachment-id (:id attachment)
        last-attachment-id (uix/state attachment-id)]

    (uix/effect!
      (fn []
        (go
          (when (and show-markup? query)
            (reset! page-blocks (<! (fetch-ocr-markup query)))
            (reset! last-attachment-id attachment-id))))
      [query show-markup?])

    (when show-markup?
      [:<>
       (for [{:keys [id x y viewport]} pages
             :let [h (.-height viewport) w (.-width viewport)
                   to-h (partial * h) to-w (partial * w)]]
         ^{:key id}
         [:div {:class :ncr-c-ocr-page :style {:position "absolute" :top y :left x :height h :width w}}
          [:div {:class :ncr-c-ocr-page__number} (str "Page #" id)]
          (let [page-blocks @page-blocks]
            (if (and page-blocks (= @last-attachment-id attachment-id))
              [:<>
               (for [{:keys [Id suggested-dates suggested-moneys] :as block} (get page-blocks id)]
                 ^{:key Id}
                 [c-block
                  {:active? (contains? active-blocks-ids Id)
                   :money? (seq suggested-moneys)
                   :date? (seq suggested-dates)
                   :block block :to-w to-w :to-h to-h
                   :on-click #(update-blocks block %)}])]
              [pf/c-spinner {:size :md :style {:position "relative" :top 10 :left 10}}]))])])))
